(function () {
  angular.module("akitabox.serviceRequest").run(states);

  /* @ngInject */
  function states(models, Router) {
    Router.configureStates([
      {
        state: "app.serviceRequests",
        config: {
          abstract: true,
          url: "/" + models.SERVICE_REQUEST.ROUTE_PLURAL,
          template: '<div flex layout="column" layout-fill ui-view ></div>',
        },
      },
      {
        state: "app.serviceRequests.new",
        config: {
          url: "/new",
          templateUrl:
            "app/mobile/modules/service-request/new-list/new-list.html",
          controller: "NewServiceRequestListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            query: getQuery,
          },
          data: {
            pageTitle: "New Service Requests",
          },
        },
      },
      {
        state: "app.building.serviceRequest",
        config: {
          abstract: true,
          url: "/" + models.SERVICE_REQUEST.ROUTE_PLURAL + "/:requestId",
          template: '<div flex layout="column" layout-fill ui-view ></div>',
          resolve: {
            serviceRequest: getServiceRequest,
          },
        },
      },
      {
        state: "app.building.serviceRequests",
        config: {
          url: "/" + models.SERVICE_REQUEST.ROUTE_PLURAL + "?status",
          templateUrl: "app/mobile/modules/service-request/list/list.html",
          controller: "ServiceRequestListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            query: getQuery,
            status: getStatus,
          },
          data: {
            pageTitle: "Service Requests",
          },
        },
      },
    ]);
  }

  // ------------------------
  //   Detail
  // ------------------------

  /** @ngInject */
  function getServiceRequest(
    /* Angular */
    $q,
    /* Third-party */
    $stateParams,
    /* Akitabox */
    models,
    /* Constants */
    NOT_ALLOWED_VIEW_DETAIL_PREFIX,
    /* Resolve */
    account,
    building,
    /* Services */
    RequestService
  ) {
    return RequestService.getById(building._id, $stateParams.requestId);
  }

  // ------------------------
  //   List
  // ------------------------

  /** @ngInject */
  function getQuery(account, $stateParams) {
    return $stateParams.q;
  }

  /** @ngInject */
  function getStatus(account, $stateParams) {
    return $stateParams.status;
  }
})();
